import type { Issue } from './types';

export const issueFromRow = (row: any): Issue => ({
  id: row.id, teamId: row.team_id ?? undefined, title: row.title,
  description: row.description ?? undefined, ownerId: row.owner_id ?? undefined,
  priority: row.priority as any, resolved: row.resolved,
  status: (row.status ?? (row.resolved ? 'resolved' : 'open')) as any,
  createdAt: row.created_at_date, resolvedAt: row.resolved_at ?? undefined,
  year: row.year ?? undefined, quarter: row.quarter ?? undefined,
  rockId: row.rock_id ?? undefined, processId: row.process_id ?? undefined,
  processStepId: row.process_step_id ?? undefined,
  insightId: row.insight_id ?? undefined,
  insightConditionKey: row.insight_condition_key ?? undefined,
  queuedAction: row.queued_action ?? undefined,
});
